<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="110px" label-suffix="：" inline>
      
      <el-form-item label="品牌名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入品牌名称" v-trim/>
      </el-form-item>
      <el-form-item label="所属板块" prop="module">
        <el-select
          v-model="form.module"
          placeholder="请选择所属板块"
        >
          <el-option
            :key="0"
            :value="0"
            label="平台商城"
          ></el-option>
          <el-option
            :key="1"
            :value="1"
            label="咖豆商城"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序码(升序)" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码" v-trim/>
      </el-form-item>
      
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaProductLabelWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        module: '',
        type: '1',
        sortnum: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, messgae: '请输入品牌名称', tigger: 'blur' }
        ],
        type: [
          { required: true, messgae: '请选择所属板块', tigger: 'change' }
        ],
      }
    }
  },
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
